// "use client";

import Link from "next/link";

const SITEMAP = [
  {
    title: "Contact Us",
    menu: ["info@nubitsoft.com", "+92(21) 32428196-98", "Suite # 101-102, Roshan Trade Center (TAI),", "Near Naheed Super Market ", "Shaheed-e-Millat Road Karachi, Pakistan.",],
  },
  {
    title: "Trending Tech",
    menu: ["Full Stack Development", "Machine Learning & AI", "NFT MarketPlace", "Cyber Security", "Augmented Reality"],
  },
  {
    title: "Industries",
    menu: [
      "Banking & Financial Services",
      "Education",
      "Healthcare",
      "Retail E-Commerce",
      "Stock Brokerage & Trading"
    ]
  },
  {
    title: "Quick Link",
    links: ["About", "PrivacyPolicy", "Contact ", "Facebook", "LinkedIn", "YouTube"],
  },
];
// console.count("footer")
export function Footer() {
  return (
    <footer className="relative w-full bg-[#020617] text-white overflow-hidden">
      {/* top hairline accent */}
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-brand-500/60 to-transparent" />
      <div className="pointer-events-none absolute -top-24 left-1/2 -translate-x-1/2 h-64 w-[40rem] rounded-full bg-brand-600/10 blur-3xl" />

      <div className="relative mx-auto max-w-7xl px-6 sm:px-8">

        <div className="grid grid-cols-1 gap-10 py-16 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 justify-items-center md:justify-items-start">

          {SITEMAP.map(({ title, links, menu }, index) => (
            <div key={index} className="w-full max-w-[300px] md:max-w-none text-left">
              <h3 className="mb-6 font-semibold uppercase text-brand-300 text-xs tracking-[0.2em]">
                {title}
              </h3>

              <ul className="space-y-3 text-sm">
                {links?.map((link, i) => (
                  <li key={i}>
                    <Link
                      href={
                        link === "linkedIn" ? 'https://www.linkedin.com/company/nubit-software-pvt-ltd/' :
                          link === "Facebook" ? 'https://www.facebook.com/Nubitsoftware' :
                            link === "YouTube" ? 'https://www.youtube.com/@nubitsoft' :
                              `/${link.toLowerCase()}`
                      }
                      className="inline-block text-slate-300 transition-all duration-200 hover:translate-x-1 hover:text-white"
                    >
                      {link}
                    </Link>
                  </li>
                ))}

                {menu?.map((item, i) => (
                  <li key={i}>
                    <span className="inline-block text-slate-400">
                      {item}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

      </div>
    </footer>
  );
}
